<div class="container-fluid">
    <div class="row">
        <div class="page-title col-md-12">
            <h2> {{'product.product' | translate}} : {{ currentLanguage == 'fr'? offer.product.productNameFr :
                offer.product.productName }}</h2>
        </div>
    </div>
    <div class="row">
        <div class="col-md-10">
            <ng-template #section>
                <div class="recent-orders">
                    <br />
                    <section id="offer-products-details" class="product-section">
                        <h4>{{'product.details' | translate}} &nbsp;&nbsp;
                            <a [routerLink]="'/user/' + user.id + '/products/' + offerId + '/edit'">
                                <i class="fa fa-edit"></i>
                            </a>
                        </h4>
                        <table class="table table-bordered">
                            <tbody>
                                <tr>
                                    <td>
                                        <label>{{'common.quantity' | translate}}</label> : {{ offer.qty}}
                                    </td>
                                    <td>
                                        <label>{{'product.measurement_unit' | translate}}</label> : {{ currentLanguage
                                        == 'fr'? offer.measurementunit.descriptionFr :
                                        offer.measurementunit.description}}
                                    </td>
                                    <td>
                                        <label>{{'product.price' | translate}}</label> : {{ offer.price }} {{
                                        offer.currency | uppercase}}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>{{'product.pricing' | translate}}</label> : {{ currentLanguage === 'fr'?
                                        offer.pricing.nameFr : offer.pricing.name }}
                                    </td>
                                    <td *ngIf="offer.pricing.name === 'Promotion'">
                                        <label>{{'product.percent_discount' | translate}} </label> :
                                        {{offer.percentDiscount}}
                                    </td>
                                    <td [attr.colspan]="offer.pricing.name === 'Promotion' ? 1 : 2">
                                        <label>{{'product.condition' | translate}} </label> : {{ currentLanguage ===
                                        'fr'? offer.productCondition.descriptionFr : offer.productCondition.description
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>{{'offers.product_weight' | translate}}</label> : {{
                                        offer.productWeightInKilo }} kg
                                    </td>
                                    <td *ngIf="offer.availableDate">
                                        <label>{{'offers.available_date' | translate}}</label> : {{ offer.availableDate
                                        | date:'shortDate' }}
                                    </td>
                                    <td *ngIf="!offer.availableDate" [attr.colspan]="2">
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3">
                                        <label>{{'product.description' | translate}} </label> :
                                        <br />
                                        <div [innerHTML]="offer.description ">
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </section>
                    <section id="offer-product-images" class="product-section">
                        <div>
                            <h4>{{'product.images' | translate}}</h4>
                            <div class="with-border">
                                <ng-template #imageBlock>
                                    <div class="screenshots">
                                        <div id="pictures">
                                            <div class="product-img" *ngFor="let media of mediaList"
                                                id="img-{{ media.id }}">
                                                <img [src]="getImageSrc(media.path)" alt="" />
                                                <span (click)="deleteOfferPicture(media)"><i
                                                        class="fa fa-remove"></i></span>
                                            </div>
                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                    <div class="status" style="text-align: right" *ngIf="totalOfImages < 6 ">
                                        <button class="btn"
                                            (click)="chooseFiles('image-field-1')">{{'common.browse_files' | translate}}
                                        </button>
                                        <input type="file" (change)="onChange($event)" name="picture"
                                            style="display: none;" id="image-field-1">
                                    </div>
                                </ng-template>
                                <p *ngIf="!hasPictures else imageBlock " id="browseBtnBlock">
                                    <span style="font-size: 12px; margin-bottom: 10px;">{{'product.message_add_image' |
                                        translate}}</span>
                                    <button class="btn" (click)="chooseFiles('image-field-2')">{{'common.browse_files' |
                                        translate}}</button>
                                    <input type="file" (change)="onChange($event)" name="picture" style="display: none;"
                                        id="image-field-2">
                                </p>
                                <!-- <image-cropper [imageChangedEvent]="imageChangedEvent"
                                    (imageCropped)="imageCropped($event)" [autoCrop]="true" [resizeToWidth]="320">
                                </image-cropper> -->
                            </div>
                        </div>
                    </section>
                    <!-- ==================== NEW SHIPPING OPTIONS SECTION ==================== -->
                    <section id="offer-shipping-options" class="product-section">
                        <div>
                            <h4>{{'offers.shipping_options' | translate}}</h4>
                            <div class="with-border">
                                <div *ngIf="selectedShippingOptions.length === 0 && !offer?.localPickup" class="text-muted">
                                    {{'offers.no_shipping_options_selected' | translate}}
                                </div>
                                <div *ngIf="selectedShippingOptions.length > 0 || offer?.localPickup" class="selected-options-tags">
                                    <span class="badge bg-success me-2 mb-2" *ngIf="offer?.localPickup === true">
                                        {{ 'offers.local_pickup' | translate }}
                                    </span>
                                    <span class="badge bg-success me-2 mb-2"
                                        *ngFor="let optId of selectedShippingOptions">
                                        {{ getOptionName(optId) }}
                                        <button type="button" class="btn-close btn-close-white ms-1"
                                            style="font-size: 0.6rem;" (click)="removeSelectedOption(optId)"></button>
                                    </span>
                                </div>
                                <button class="btn btn-success mt-3" (click)="openShippingOptionsModal()">
                                    {{'offers.add_shipping_option' | translate}}
                                </button>
                            </div>
                        </div>
                    </section>

                    <!-- ==================== OLD SHIPPING OFFER SECTION (COMMENTED OUT) ====================
                    <section id="offer-shipping-offers" class="product-section">
                        <div>
                            <h4>{{'orders_list.shipping_offers' | translate}}</h4>
                            <div class="with-border">
                                <div *ngIf="!formShippingOpened else shippingOfferForm;">
                                    <ol id="shipping-offers-list">
                                        <li *ngFor="let s of shippingOffers">
                                            <p>
                                                <span class="float-li">
                                                    {{ s.shippingMean.shippingType.description }}
                                                    ({{ s.shippingMean.country.name | titlecase }}) :
                                                    {{ s.shippingMean.description }}
                                                    , {{ s.shippingCost }} {{ s.scur | uppercase }}
                                                    , {{ s.eta > 1 ? s.eta + ' days' : '1 day' }}
                                                </span>
                                                <span>
                                                    <a class="btn-edit-2" (click)="editShippingOffer(s)"></a>
                                                </span>
                                                <span>
                                                    <a class="btn-remove" (click)="deleteShippingOffer(s)"></a>
                                                </span>
                                                <span class="clear-fix"></span>
                                            </p>
                                        </li>
                                    </ol>
                                    <ul style="list-style: none; padding-left: 25px;">
                                        <li>
                                            <p>
                                                <button class="btn btn-success" (click)="openShippingOfferForm()">
                                                    {{'orders_list.add_shipping_offer' | translate}}
                                                </button>
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                                <ng-template #shippingOfferForm>
                                    <app-shipping-offer-form [formShippingOpened]="formShippingOpened"
                                        [shippingTypes]="shippingTypes" [offer]="offer"
                                        [currentShippingOffer]="shippingOffer"
                                        (shippingOffer)="saveShippingOffer($event)"
                                        (changeStatus)="closeShippingOfferForm($event)"></app-shipping-offer-form>
                                </ng-template>
                            </div>
                        </div>
                    </section>
                    -->

                </div>
            </ng-template>
            <p *ngIf="loading else section" style="text-align: center; padding: 10px 0;">
                <label>{{'common.loading' | translate}} ...</label>
            </p>
        </div>
        <div class="col-md-2">
            <app-sidebar [currentUser]="user"></app-sidebar>
        </div>
    </div>
</div>

<!-- Shipping Options Selection Modal -->
<div class="modal shipping-options-modal" tabindex="-1" role="dialog"
    [ngClass]="{ 'd-block': showShippingOptionsModal }" *ngIf="showShippingOptionsModal">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ 'offers.select_shipping_options' | translate }}</h5>
                <button type="button" class="btn-close" (click)="closeShippingOptionsModal()"></button>
            </div>
            <div class="modal-body">
                <div *ngIf="modalLoading" class="text-center py-4">
                    {{ 'common.loading' | translate }} ...
                </div>
                <div *ngIf="!modalLoading && modalShippingOptions.length === 0" class="text-muted">
                    {{ 'offers.no_shipping_options' | translate }}
                </div>

                <!-- Option Cards -->
                <div *ngIf="!modalLoading && modalShippingOptions.length > 0" class="shipping-options-cards">
                    <div class="card mb-3" *ngFor="let option of modalShippingOptions">
                        <div class="card-header d-flex justify-content-between align-items-center">
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input"
                                    [id]="'modal-shipping-option-' + option.id"
                                    [checked]="isModalOptionSelected(option.id)"
                                    (change)="toggleModalOption(option.id)" />
                                <label class="form-check-label fw-bold ms-2"
                                    [for]="'modal-shipping-option-' + option.id">
                                    <i class="fa fa-truck me-2 text-success"></i>
                                    {{ option.logisticAgent }}
                                    <small class="d-block text-muted fw-normal">{{ option.shippingType?.description }} —
                                        {{ option.country?.name }}</small>
                                </label>
                            </div>
                        </div>
                        <div class="card-body" *ngIf="isModalOptionSelected(option.id)">
                            <div *ngIf="modalPricingLoading.get(option.id)" class="text-center py-2">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                {{ 'common.loading' | translate }} ...
                            </div>
                            <div *ngIf="!modalPricingLoading.get(option.id)">
<div *ngFor="let pricing of modalShippingPricings.get(option.id)">
                                    <!-- Coverage / Locations (Primary Focus) -->
                                    <div class="coverage-info mb-3 p-2 bg-light rounded"
                                        *ngIf="hasCoverageData(option, pricing)">
                                        <!-- International coverage -->
                                        <div *ngIf="isInternationalOption(option)">
                                            <span class="badge bg-success mb-1">{{ 'shipping_pricing.coverage' |
                                                translate }}</span>
                                            <div class="fw-bold">
                                                <span *ngIf="pricing.allCountries" class="text-success">{{
                                                    'shipping_pricing.all_countries_worldwide' | translate }}</span>
                                                <span *ngIf="!pricing.allCountries && pricing.countries?.length">
                                                    <span *ngFor="let c of pricing.countries; let last=last">{{ c.name
                                                        }}<span *ngIf="!last">, </span></span>
                                                </span>
                                            </div>
                                        </div>
                                        <!-- InterCity/IntraCity cities -->
                                        <div *ngIf="isCityBasedOption(option)">
                                            <span class="badge bg-info mb-1">{{
                                                'shipping_pricing.operating_cities' | translate }}</span>
                                            <div class="fw-bold">
                                                <span *ngIf="pricing.allCities" class="text-success">{{
                                                    'shipping_pricing.all_cities' | translate }}</span>
                                                <span *ngIf="!pricing.allCities && pricing.cities?.length">
                                                    <span *ngFor="let c of pricing.cities; let last=last">{{ c.cityName
                                                        }}<span *ngIf="!last">, </span></span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="!hasModalPricingCoverage(option)" class="text-muted mt-2">
                                    {{ 'offers.shipping_option_not_available_for_condition' | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeShippingOptionsModal()">
                    {{ 'common.cancel' | translate }}
                </button>
                <button type="button" class="btn btn-success" (click)="saveModalSelections()">
                    {{ 'common.save' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade show" *ngIf="showShippingOptionsModal"></div>